export const isNull = (value) => value === null

export const isUndefined = (value) => value === undefined

export const isNullOrUndefined = (value) =>
  value === undefined || value === null
